import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Box, Button, Divider, Typography } from "@material-ui/core";

import { trackEventKeepRenewalScreen, trackEventTurnRenewalOffScreen } from "utils/gAnalyticsUtils";
import { appRoutes, externalRoutes } from "routes";
import { useUsers } from "hooks";
import Placeholder from "components/Placeholder";
import AccountLayout from "layouts/AccountLayout";

import { SectionHeader, LinkStyledButton, CancelFeedbackModal, TurnOffRenewalModal } from "../components";

import useStyles from "./useStyles";

const EditRenewal = () => {
  const classes = useStyles();
  const [feedbackModalVisible, setFeedbackModalVisible] = useState(false);
  const [renewalModalVisible, setRenewalModalVisible] = useState(false);
  const { currentUser } = useUsers();

  const handleFeedbackModalOpen = () => {
    trackEventTurnRenewalOffScreen();
    setFeedbackModalVisible(true);
  };
  const handleFeedbackModalClose = () => setFeedbackModalVisible(false);

  const handleRenewalModalOpen = () => setRenewalModalVisible(true);
  const handleRenewalModalClose = () => setRenewalModalVisible(false);

  return (
    <AccountLayout
      title="eCards - Customize & Send Funny Greeting Cards Online - JibJab"
      backLink={appRoutes.subscriptionDetailsPath()}
    >
      {currentUser ? (
        <>
          <SectionHeader first>Membership Description</SectionHeader>
          <Typography className={classes.text}>We love having you as a member!</Typography>

          <NavLink exact className={classes.link} to={appRoutes.subscriptionDetailsPath()}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={trackEventKeepRenewalScreen}
            >
              Keep Renewal On
            </Button>
          </NavLink>

          <Divider className={classes.divider} />
          <Typography className={classes.text}>Not quite sure?</Typography>

          <Box className={classes.renewalButton}>
            <LinkStyledButton handleClick={handleFeedbackModalOpen}>Turn Renewal Off</LinkStyledButton>
          </Box>

          <Typography>
            Your membership will not renew and you will lose access to JibJab Member Exclusive content when your
            membership expires.
          </Typography>

          <Typography variant="caption" display="block" className={classes.captionText}>
            If you have any questions regarding this membership, please{" "}
            <a href={externalRoutes.helpPath()} rel="noreferrer" target="_blank">
              visit our Support Center for Help
            </a>
            .
          </Typography>

          {feedbackModalVisible && (
            <CancelFeedbackModal onClose={handleFeedbackModalClose} onFeedbackSent={handleRenewalModalOpen} />
          )}
          {renewalModalVisible && <TurnOffRenewalModal onClose={handleRenewalModalClose} />}
        </>
      ) : (
        <>
          <SectionHeader first>Membership Description</SectionHeader>
          <Placeholder variant="text" className={classes.placeholder} />

          <SectionHeader>Renewal</SectionHeader>
          <Placeholder variant="text" className={classes.placeholder} />

          <SectionHeader>Billing Info</SectionHeader>
          <Placeholder variant="text" className={classes.placeholder} />
        </>
      )}
    </AccountLayout>
  );
};

export default EditRenewal;
